import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, IStorage, Kindergarten, LocalStorage } from '@isophi/core-legacy';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Subscription } from 'rxjs';

import { UserService } from '../../../../core/services/user.service';
@Component({
  selector: 'app-workplace-selector',
  templateUrl: './workplace-selector.component.html',
  styleUrls: ['./workplace-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplaceSelectorComponent implements OnInit, OnDestroy {
  kindergartens$ = new BehaviorSubject<Kindergarten[]>([]);
  currentKindergarten$ = new BehaviorSubject<Kindergarten | null>(null);
  isLoading = false;

  private _subs: Subscription[] = [];
  private localStorage: IStorage;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef
  ) {
    this.localStorage = new LocalStorage();
  }

  get selectedKindergartenUUID(): string | null {
    return this.userService.getCurrentKindergartenUUID();
  }

  get kindergartens(): Kindergarten[] {
    return this.kindergartens$.value;
  }

  get currentKindergarten(): Kindergarten | null {
    return this.currentKindergarten$.value;
  }

  trackByKindergartenId(index: number, kindergarten: Kindergarten): number {
    return kindergarten.id;
  }

  ngOnInit(): void {
    this.loadKindergartens();
    this.loadCurrentKindergarten();
    this._subs.push(
      this.userService.loggedKindergarten$.subscribe((kindergarten) => {
        if (kindergarten) {
          this.currentKindergarten$.next(kindergarten);
          this.cd.markForCheck();
        }
      })
    );
  }

  private loadKindergartens(): void {
    const teacher = this.authService.loggedUser?.teacher;
    if (!teacher) {
      return;
    }

    // Get kindergartens from teacher data
    let kindergartens: Kindergarten[] = [];
    if (teacher.kindergartens && teacher.kindergartens.length > 0) {
      kindergartens = teacher.kindergartens;
    }

    this.kindergartens$.next(kindergartens);
    this.cd.markForCheck();
  }

  private loadCurrentKindergarten(): void {
    const current = this.userService.loggedKindergarten;

    this.currentKindergarten$.next(current);
    this.cd.markForCheck();
  }

  async onKindergartenSelect(kindergarten: Kindergarten): Promise<void> {
    const currentSelectedUUID = this.userService.getCurrentKindergartenUUID();
    if (kindergarten.uuid === currentSelectedUUID) {
      return; // Already selected
    }
    this.userService.setSelectedKindergarten(kindergarten.uuid);
    this.authService.storeToken(this.localStorage);

    // Update current kindergarten display
    this.currentKindergarten$.next(kindergarten);
    window.location.reload();

    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
}
